import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { PageHeader } from "../../layout/AppLayout";
import { ErpTable } from "../../components/erp";
import { errorText } from "../../api/client";
import { AbReportListRow, abReportApi } from "./api";

const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

/** Port of v3/QualityControl/DailyLabReports.php + Ajax/AjDlyLbRprts.php — AB reports grouped by AnalysisDate. */
export default function AbReportsList() {
  const now = new Date();
  const [month, setMonth] = useState(String(now.getMonth() + 1));
  const [year, setYear] = useState(String(now.getFullYear()));
  const list = useQuery({ queryKey: ["qc", "ab-reports", month, year], queryFn: () => abReportApi.list({ Month: month, Year: year }) });

  return (
    <>
      <PageHeader title="Antibiotic Reports" location="Quality Control" />
      <div className="card"><div className="card-body">
        <div className="row rowFilter mb-3">
          <div className="col-md-3">
            <select className="form-select" value={month} onChange={(e) => setMonth(e.target.value)} data-testid="ab-report-month">
              {MONTHS.map((m, i) => <option key={m} value={i + 1}>{m}</option>)}
            </select>
          </div>
          <div className="col-md-3">
            <input className="form-control" type="number" value={year} onChange={(e) => setYear(e.target.value)} data-testid="ab-report-year" />
          </div>
          <div className="col-md-3">
            <Link className="btn btn-success" to={`/v3/QualityControl/RmAbReport?Month=${month}&Year=${year}`} data-testid="ab-report-create-btn">Create Report</Link>
          </div>
        </div>
        <ErpTable<AbReportListRow> testId="ab-report-list-table" loading={list.isLoading}
          error={list.isError ? errorText(list.error) : list.data?.Error || null}
          rows={list.data?.Data || []}
          columns={[
            { key: "AnalysisDate", title: "Analysis Date" }, { key: "ReportDate", title: "Report Date" },
            { key: "TotalReports", title: "Total Reports" }, { key: "DayTotal", title: "Day" }, { key: "NightTotal", title: "Night" },
            { key: "Action", title: "Action", render: (r) => (
              <Link className="btn btn-sm btn-primary" data-testid={`ab-report-add-${r.AbRepID}`}
                to={`/v3/QualityControl/RmAbReport?AnalysisDate=${r.AnalysisDateRaw}&Month=${month}&Year=${year}`}>Add / View</Link>
            ) },
          ]} />
      </div></div>
    </>
  );
}
